export default class DateUtils {
    static formatterOptions = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    static toLocalDateString = (dateString) => {
        const createdAt = new Date(dateString);

        return createdAt.toLocaleDateString("en-US", DateUtils.formatterOptions);
    };
}